import { memo, useState } from "react";
import { Sync } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useAlertContext } from "components/context/AlertContext";
import { StorageUtil } from "utils";
import { remoteApiFactory } from "services";
import { ApiConstant } from "const";
import { getInteractor } from "services/local.service";
import { getRemoteBranchAccount } from "pubsub/services/branch.service";
import { getCommonLang } from "utils/lang.utils";
import { formatPagingParams } from "sagas/saga.helper";

const SyncContact = ({ isBranchServer, onSuccess }) => {
  const prefixKey = StorageUtil.getCurrentPrefixKey();
  const { showAlert } = useAlertContext();

  const [isFetching, setIsFetching] = useState(false);

  const handleSynchContact = async () => {
    setIsFetching(true);
    let isSuccessContact = false;
    let isSuccessAccount = !isBranchServer;

    // Force to synch contact
    try {
      const contactResponse = await remoteApiFactory
        .getBranchApi(prefixKey)
        .getContactList(formatPagingParams({ limit: 10000 }));

      if (contactResponse.status === ApiConstant.STT_OK && Array.isArray(contactResponse.data?.data)) {
        const responseData = contactResponse.data.data;
        await getInteractor(prefixKey).LocalContactService.save(responseData);
        isSuccessContact = true;
      }
    } catch (error) {
      console.error("Synch contact", error);
    }

    // Force to synch account
    if (isBranchServer) {
      try {
        const accountResponse = await getRemoteBranchAccount(prefixKey);
        if (Array.isArray(accountResponse)) {
          isSuccessAccount = true;
        }
      } catch (error) {
        console.error("Synch contact", error);
      }
    }

    if (isSuccessContact && isSuccessAccount) {
      if (onSuccess) onSuccess();
      showAlert({ content: getCommonLang("SYNCH_CONTACT_SUCCESS") });
    } else {
      showAlert({ content: getCommonLang("SYNCH_CONTACT_FAILED"), severity: "error" });
    }
    setIsFetching(false);
  };

  return (
    <IconButton color="primary" sx={{ mx: 0.5 }} onClick={handleSynchContact} disabled={isFetching}>
      <Sync />
    </IconButton>
  );
};

export default memo(SyncContact);
